
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my-profile",
      function () {
        return require("private-next-pages/my-profile/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my-profile"])
      });
    }
  